import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataStateChangeEventArgs, GridComponent, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalComponent } from 'src/app/global/global.component';
import { LocationBO, GetLocationBO, functionpermission } from './location.modal';
import { LocationService } from './location.service';
import { LocationDateService } from './locationdateservice';

@Component({
  selector: 'app-location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.scss']
})
export class LocationComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  LocationForm: FormGroup;
  LocationType: string;
  public filterSettings: object;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  initialPage: PageSettingsModel;
  @ViewChild('gridLocation') public gridLocation: GridComponent;
  public GridList: Observable<DataStateChangeEventArgs>;
  saveLocation: LocationBO = new LocationBO();
  FilterBo: GetLocationBO = new GetLocationBO();
  fp:functionpermission=new functionpermission();
  isSaveorUpdateBoolean:boolean=false;
  constructor(public getLocationService: LocationDateService,
    public global: GlobalComponent, private formBuilder: FormBuilder, 
    public LService: LocationService, public toasterService: ToastrService,) {

    this.LocationForm = this.formBuilder.group({
      LocationName: [' ', Validators.required],
      StartDayName:['', Validators.required],
      EndDayName:['']
    });

    this.global.checkforlogout();
    this.GridList = getLocationService;
  }

  ngOnInit(): void {
    if(this.global.globalAgencyId == null ||
      this.global.globalAgencyId == undefined ||
      this.global.globalAgencyId == "" ||
      this.global.globalAgencyId == "00000000-0000-0000-0000-000000000000") 
     {
      return;
    }
    this.filterSettings = {
      type: 'Menu',
    };
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
    this.getLocationFilter();
    this.GetWeekDayDropdown();
    this.getpermission()
  }
  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId!=null&&this.global.globalAgencyId!=undefined&&this.global.globalAgencyId!='')) {
    let params = new URLSearchParams();
    params.append("pagecode", "Location");
    params.append("roleId", this.global.roleId);
    params.append("agencyId", this.global.globalAgencyId)
    this.LService.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

      if (data != null) {
        this.fp = data;

      }
      else {
        this.fp = new functionpermission();
      }
    },
      (err: HttpErrorResponse) => {
        this.fp = new functionpermission();
      })
  }
}
  //.........................................CreateLocationList.............................................
  CreateorUpdateLocationList(data) {
    this.LocationType = data;
    if (this.LocationType == 'CreatelocationModal') {
      this.saveLocation = new LocationBO();
      this.LocationForm.reset();
      // this.saveLocation.weekStartDayLid=this.LocationDropdown.filter((e)=> e.lovName =="Sunday")[0].id
    }
  }

  // ................................................dataChangeLov..............................................
  public dataChangeLocation(Location): void {
    let val = (Location.action.requestType).toString();
    if (val != "filterchoicerequest") {
      if ((Location.sorted || []).length) {
        this.FilterBo.orderColumn = Location.sorted[0].name;
        this.FilterBo.orderType = Location.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (val == "filtering" && Location.action.action != "clearFilter") {
      this.FilterBo.value = Location.action.currentFilterObject.value;
      this.FilterBo.field = Location.action.currentFilterObject.field;
      this.FilterBo.matchCase = Location.action.currentFilterObject.matchCase;
      this.FilterBo.operator = Location.action.currentFilterObject.operator;
    }
    else {
      if (val == "filtering" && Location.action.action == "clearFilter") {
        this.FilterBo.field = "name";
        this.FilterBo.matchCase = false;
        this.FilterBo.operator = "contains";
        this.FilterBo.value = "";
        this.FilterBo.type = "string"
      }
    }
    this.getLocationFilter();
    if (val == "paging" && Location.action.name == "actionBegin") {
      
    }
  }
  //.........................................onActionLov.....................................................
  public onActionLocation(Location) {
    this.FilterBo.currentpageno = this.gridLocation.pagerModule.pagerObj.currentPage;
    this.FilterBo.pageitem = this.gridLocation.pagerModule.pagerObj.pageSize;
    if (Location.name == "actionBegin" && Location.requestType == "filterbeforeopen") {
      this.FilterBo.type = Location.columnType
    }
  }
  //...........................................getDetails..........................................
  getDetails(saveBos: LocationBO) {
    this.saveLocation = JSON.parse(JSON.stringify(saveBos));
  this.saveLocation.weekStartDayLid=this.locationValue.filter((e) => e.lovName == saveBos.weekStartDayLovName)[0].id
  this.saveLocation.weekStartDayLid=this.locationValue.filter((e) => e.lovName == saveBos.weekEndDayLovName)[0].id
  
  }

  //.........................................Refresh.............................................
  clearLocation(type: string) {
    this.LocationType = null;
    this.saveLocation = new LocationBO();
    this.LocationForm.reset();
    if (type == "refresh") {
      this.getLocationFilter();
    }
  }
  //.........................................getLocationFilter.............................................
  getLocationFilter() {
    // this.FilterBo.agencyId=this.global.globalAgencyId;
    this.getLocationService.execute(this.FilterBo);
    let count = 0;
    this.GridList.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      count = count + 1;
      if (data != null && data.result.length > 15) {
        this.gridLocation.height = '500';
      }
      else {
        this.gridLocation.height = 'auto';
      }
    })
  }
  //.........................................SaveOrUpdateLocation.............................................
  SaveOrUpdateLocation() {
    this.isSaveorUpdateBoolean=true;
    let saveLocationbilling: LocationBO = JSON.parse(JSON.stringify(this.saveLocation));
    saveLocationbilling.id = this.saveLocation.id;;
    saveLocationbilling.weekStartDayLid = this.saveLocation.weekStartDayLid != null ? this.saveLocation.weekStartDayLid  : null;
    saveLocationbilling.weekEndDayLid = this.saveLocation.weekEndDayLid != null ? this.saveLocation.weekEndDayLid  : null;
    this.LService.SaveorUpdateLocation(saveLocationbilling).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.isSaveorUpdateBoolean=false;
      if (data) {
        if (this.LocationType == 'CreatelocationModal') {
          this.toasterService.success('Location saved successfully!');
          setTimeout(() => {
            this.toasterService.clear();
          }, 8000);

        }
        else if (this.LocationType == 'UpdatelocationModal') {
          this.toasterService.success('Location updated successfully!');
          setTimeout(() => {
            this.toasterService.clear();
          }, 8000);
        }
        document.getElementById('openLocationModal').click();
        this.LocationForm.reset();
        this.getLocationFilter();
      }
    }, (err: any) => {
      this.isSaveorUpdateBoolean=false;
      if (err) {
        this.toasterService.error(err, 'Error'), 8000;
      }
    })
  }
  //.....................................showLocationColumns....................................
  showLocationColumns() {
    this.gridLocation.columnChooserModule.openColumnChooser(200, 50);
  }
  //..........................................DeleteLocation...........................................................
  DeleteLocation() {
    this.LService.DeleteLocation(this.saveLocation.id).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.toasterService.success('Location deleted successfully!');
      setTimeout(() => {
        this.toasterService.clear();
      }, 8000);
      document.getElementById('closeLocationModal').click();
      this.getLocationFilter();
    }, (err: any) => {
      if (err) {
        this.toasterService.error(err, 'Error'), 8000;
      }
    });


  }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
  
  LocationDropdown:any=[
  

  ];

  locationValue:any = [];
  GetWeekDayDropdown() {
    let param = new URLSearchParams();
    param.append("listCode","WEEKSTARTDAY")
    this.LService.GetLovDropdown(param).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.LocationDropdown = JSON.parse(JSON.stringify(data));
      this.LocationDropdown.unshift({lovName:"",id:0})
      this.locationValue = JSON.parse(JSON.stringify(data))

    });

  }

  daychange() {
    if (this.saveLocation.weekStartDayLid == 0) {
        this.saveLocation.weekEndDayLid = null;
    }
    if (this.saveLocation.weekStartDayLid  != undefined && this.saveLocation.weekStartDayLid  != null) {
        let getDays = this.locationValue?.map(d => d.id)
        let start = getDays?.indexOf(this.saveLocation.weekStartDayLid.toString())
        if (start == 0) {
            this.saveLocation.weekEndDayLid = this.locationValue[this.locationValue.length - 1].id
        }
        else if (start != -1) {
            this.saveLocation.weekEndDayLid = this.locationValue[start - 1].id
        }
    }

}


  infoToast() 
  {
   this.toasterService.error( "Location is Mapped With Clients,Employees,Users","Unable to delete");
   setTimeout(() => {
     this.toasterService.clear()
   }, 8000);  
       
     }
 

}
